import React from 'react';
import { Container, Typography, Box } from '@mui/material';

function Research() {
    const researchThemes = [
        {
            title: "Global Optimization Methods",
            description: "",
            embedUrl: "https://docs.google.com/presentation/d/e/2PACX-1vQR76mUbC1-URka07LoN-oc-6E3jgpHwX5kLSQHdoEki5Nyz5-8irtw5OhQGjub_puaA7NxGl4j-kwY/embed",
        },
        {
            title: "Chemical Data Modeling",
            description: "",
            embedUrl: "https://docs.google.com/presentation/d/e/2PACX-1vQO30Q9jERzQvz2a1VahaswjDTXKHD3WAwT4_0raN8nroGShzrh6U-Cm8n1SQpk2gsHOG-QATaE1amH/embed?start=false&loop=false",
        },
        {
            title: "Simulation-Driven Design in Engineering Applications",
            description: "",
            embedUrl: "https://docs.google.com/presentation/d/e/2PACX-1vTfPd8oG2jA1zbCXxQyUPrymqgfi_m-N9iV0A-r8MDjtBP8O0EVi1gR69kjiPXxtkaoXeWv5YOgzOBE/embed?start=false&loop=false&delayms=3000",
        },
        {
            title: "Atomic-scale Finite Element Modeling",
            description: "",
            embedUrl: "https://docs.google.com/presentation/d/e/2PACX-1vQeHnDDoDSxDZz8ylJPQmCiBSurxYYcKfpJ9KauPn8NEFpXlK2eOzV8D7gzFVlF7H-uVUhSSUsyXi7T/embed",
        },
        {
            title: "Virtual Tour Application for Sightseeing and Tourism",
            description: "",
            embedUrl: "https://docs.google.com/presentation/d/e/2PACX-1vSyPeI76Sbw0-8f71J6qghMRfeNh5w5oTcEyYPIL1bZa1UEm67GWeBwM5emLt1cDssprdLJYLbfURuq/embed",
        },
        {
            title: "Visualization and Understanding Human Activity",
            description: "",
            embedUrl: "https://docs.google.com/presentation/d/e/2PACX-1vTvPRUBR_wW8CKVRMXzNYq5eD1tHtl3No2Qbo6U4iP_eAd0c2xgP4AcE7zbNWHGVaCxHCzQPRQoDNg0/embed",
        },
    ];

    return (
        <Container>

            {researchThemes.map((theme, index) => (
                <Box key={index} mb={4}>
                    <Typography variant="h6" gutterBottom>
                        {theme.title}
                    </Typography>
                    <Typography variant="body1" paragraph>
                        {theme.description}
                    </Typography>
                    <Box
                        sx={{
                            position: 'relative',
                            paddingBottom: '56.25%', // 16:9 アスペクト比
                            height: 0,
                            overflow: 'hidden',
                            maxWidth: '100%',
                            background: '#f0f0f0',
                        }}
                    >
                        <iframe
                            src={theme.embedUrl}
                            frameBorder="0"
                            width="100%"
                            height="100%"
                            style={{ position: 'absolute', top: 0, left: 0 }}
                            allowFullScreen
                            title={theme.title}
                        ></iframe>
                    </Box>
                </Box>
            ))}
        </Container>
    );
}

export default Research;
